import { Moment } from 'moment/moment';

export function calcLedgerImportDueDate(invoiceDate: Moment, paymentTargetFromCustomer?: number) {
    if (invoiceDate && !paymentTargetFromCustomer) {
        return invoiceDate.clone().add(8, 'week');
    }
    return null;
}
